import * as React from 'react';
import * as PropTypes from 'prop-types';
import {LOAN_APPLICATION_MX} from '../../wizard/constants/LabelConstants';
import AssetsManager from '../utils/AssetsManager';
import {OptionsInsuranceProps} from '../types/components';

class OptionsInsurance extends React.Component<OptionsInsuranceProps, {}> {

    constructor(props) {
        super(props);
    }

    static defaultProps = {
        customClass: '',
    };

    onChange = (event, item, id) => {
        this.props.onChange(event);
    }

    renderLabel = (item, id) => {
        return (
            <label className="d-flex custom-control-label" htmlFor={id}>
                <div className="insurance-icon mr-3">
                    <img src={item.icon} alt={item.name}/>
                </div>
                <div className="insurance-name">{item.name}</div>
            </label>
        );
    }

    render() {
        const {options, id, name, customClass, insuranceSelectedTarget, required} = this.props;
        return (
            <div className="radio-button">
                {options.map((item, index) => {
                    const aValue = {
                        target: item.target,
                        insuranceType: LOAN_APPLICATION_MX.ANNUAL.id,
                        insuranceAmount: item.insuranceValueByYearValue
                    };
                    const inputId = `${id}-${index}`;
                    return (
                        <div key={index} className="d-flex insurance-item p-3">
                            <div className={`${customClass} insurance-option custom-control custom-radio`}>
                                <input
                                    type="radio"
                                    className={`custom-control-input ${item.target === insuranceSelectedTarget ?
                                        'checked' : ''}`}
                                    id={inputId}
                                    name={name}
                                    value={item.name}
                                    required={required}
                                    onChange={e => this.onChange(aValue, item, id)}/>
                                {this.renderLabel(item, inputId)}
                            </div>
                            <div className="insurance-value ml-auto mr-3">
                                <span className="d-sm-block">{item.insuranceValueByYear}</span>
                            </div>
                            <div className="insurance-button d-none">
                                <button className="btn btn-sm btn-outline-info rounded text-uppercase" role="button"
                                        onClick={item.onShowInfo}>{LOAN_APPLICATION_MX.MORE_INFO}</button>
                            </div>
                        </div>
                    );
                })}
            </div>
        );
    }
}

export default OptionsInsurance;
